import { createRoot } from "react-dom/client";
import { ComingSoon } from "./ComingSoon";

// NOTE: intentionally not wrapped in <StrictMode>. StrictMode double-invokes
// effects in development, which mounts→disposes→remounts the WebGL background.
// dispose() calls forceContextLoss(), and the remounted renderer can then be
// born with a lost context — leaving the canvas showing an opaque (light) buffer
// over the dark page. Mounting once keeps the background reliable.
const root = document.getElementById("root");
if (root) createRoot(root).render(<ComingSoon />);
